import {createModelSchema, alias, list, custom, serialize, SKIP, deserialize} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";
import {ChristmasProducts} from "@/modules/redactor/models/smart-offer/bundle-christmas/ChristmasProducts";
import {ChristmasTierLevels} from "@/modules/redactor/models/smart-offer/bundle-christmas/ChristmasTierLevels";


export class SmartOfferChristmasConfig extends Cloneable {

  constructor() {
    super();

    this._name = "";
    this._days = [];
    this._tierLevels = new ChristmasTierLevels();
    this._products = new ChristmasProducts();
  }

  static schema() {
    return custom((v) => {
      return v ? serialize(SmartOfferChristmasConfig, v) : SKIP;
    }, (v) => {
      return deserialize(SmartOfferChristmasConfig, v);
    });
  }

  get name() {
    return this._name;
  }

  set name(value) {
    this._name = value;
  }

  get days() {
    return this._days;
  }

  set days(value) {
    this._days = value;
  }

  get products() {
    return this._products;
  }

  set products(value) {
    this._products = value;
  }

  get tierLevels() {
    return this._tierLevels;
  }
  set tierLevels(value) {
    this._tierLevels = value;
  }

  valid() {
    if (!Array.isArray(this.days) || this.days.length === 0) {
      return false;
    }

    for (const d of this.days) {
      if (!Number.isInteger(d) || d < 1 || d > 31) {
        return false;
      }
    }

    if (this.products && !this.products.valid()) {
      return false;
    }

    if (this.tierLevels && !this.tierLevels.valid()) {
      return false;
    }

    return true;
  }

  copy() {
    return this.clone();
  }

  clone() {
    return deserialize(SmartOfferChristmasConfig, serialize(SmartOfferChristmasConfig, this));
  }
}

createModelSchema(SmartOfferChristmasConfig, {
  _name: alias("name", Schema.primitive()),
  _days: alias("days", list(Schema.primitive())),
  _tierLevels: alias("tier_levels", ChristmasTierLevels.schema()),
  _products: alias("products", ChristmasProducts.schema()),
});
